import { gql } from '@apollo/client'

export const SEARCH_PATIENT_QUERY = gql`
  query SEARCH_PATIENT_QUERY($searchTerm: String!, $showArchived: Boolean, $showLeads: Boolean) {
    searchPatients(searchTerm: $searchTerm, showArchived: $showArchived, showLeads: $showLeads) {
      id
      firstName
      lastName
      title
      type
      disabled
      phoneNumber
      patientId
      referenceId
      hasMedicalAlerts
      insuranceCompany {
        id
        name
      }
      insurancePolicy {
        id
        holderName
        policyNumber
      }
      policyClass {
        id
        name
      }
      priceList {
        id
        name
      }
      maxInsuranceLimit
      dailyAmountPaid
      lastPaymentDate
      insuranceUnlimited
      insuranceLimit
      insurancePercentage
      insuranceEndDate
      doctor {
        id
        name
      }
      prevAppointment {
        id
        status
        room
        start
        type
      }
      activeAppointment {
        id
        status
        room
        start
        type
      }
      lastAppointment {
        id
        status
        room
        start
        type
      }
    }
  }
`

export const SEARCH_USERS_QUERY = gql`
  query SEARCH_USERS_QUERY($searchTerm: String!) {
    searchUsers(searchTerm: $searchTerm) {
      id
      name
      phoneNumber
      medicalNumber
      doctorPercentage
      isDoctor
      disabled
      color
      expensesFrom
    }
  }
`
export const SEARCH_FREE_FORMS_QUERY = gql`
  query SEARCH_FREE_FORMS_QUERY($searchTerm: String!) {
    searchFreeForms(searchTerm: $searchTerm) {
      id
      content
      name
      jsonForm
      signRequired
      expiresIn
    }
  }
`
export const SEARCH_PRICE_LISTS_QUERY = gql`
  query SEARCH_PRICE_LISTS_QUERY($searchTerm: String!) {
    searchPriceLists(searchTerm: $searchTerm) {
      id
      name
      active
      syncTo
      percentage
      difference
    }
  }
`
export const SEARCH_PROCEDURES = gql`
  query SEARCH_PROCEDURES($searchTerm: String!, $chart: ChartTypes, $procedureGroup: ID, $priceList: ID) {
    searchProcedures(searchTerm: $searchTerm, chart: $chart, procedureGroup: $procedureGroup, priceList: $priceList) {
      id
      name
      code
      order
      defaultPrice
      toothEffect
      openLab
      ageGroup
      active
      taxApplied
      insuranceDiscount
      cost
      forOperator
      isPercent
      remaining
      productPriceId
      labFees
      createForm
      createLabOrder
      createPrescription
      expires
      requireCounter
      requireOperationCounter
      insuranceValue
      group {
        id
        name
      }
      active
      prices {
        id
        value
        name
        code
        active
        insuranceDiscount
        insuranceValue
        productPriceId
        parentId
      }
    }
  }
`
export const SEARCH_PROCEDURE_GROUPS = gql`
  query SEARCH_PROCEDURE_GROUPS($searchTerm: String!, $chart: ChartTypes) {
    searchProcedureGroups(searchTerm: $searchTerm, chart: $chart) {
      id
      name
      code
      active
    }
  }
`
export const SEARCH_PROCEDURE_STEPS = gql`
  query SEARCH_PROCEDURE_STEPS($searchTerm: String!, $chart: ChartTypes) {
    searchProcedureSteps(searchTerm: $searchTerm, chart: $chart) {
      id
      name
      procedure {
        id
        code
        name
        group {
          id
          name
        }
      }
    }
  }
`
export const SEARCH_GROUPS_QUERY = gql`
  query SEARCH_GROUPS_QUERY($searchTerm: String!) {
    searchGroups(searchTerm: $searchTerm) {
      id
      name
      description
      permissions
      color
    }
  }
`
export const SEARCH_BRANCHES_QUERY = gql`
  query SEARCH_BRANCHES_QUERY($searchTerm: String!) {
    searchBranches(searchTerm: $searchTerm) {
      id
      name
      disabled
    }
  }
`
export const SEARCH_PATIENT_REMINDERS = gql`
  query SEARCH_PATIENT_REMINDERS($searchTerm: String!) {
    searchPatientReminders(searchTerm: $searchTerm) {
      id
      name
      info
      details
    }
  }
`
export const SEARCH_LABS_QUERY = gql`
  query SEARCH_LABS_QUERY($searchTerm: String!) {
    searchLabs(searchTerm: $searchTerm) {
      id
      name
    }
  }
`
export const SEARCH_LAB_ITEMS_QUERY = gql`
  query SEARCH_LAB_ITEMS_QUERY($lab: ID, $searchTerm: String!) {
    searchLabItems(lab: $lab, searchTerm: $searchTerm) {
      id
      name
      images
      price
      lab {
        id
        name
      }
    }
  }
`
export const SEARCH_SUPPLIERS_QUERY = gql`
  query SEARCH_SUPPLIERS_QUERY($searchTerm: String!) {
    searchSuppliers(searchTerm: $searchTerm) {
      id
      name
    }
  }
`
export const SEARCH_MESSAGES_QUERY = gql`
  query SEARCH_MESSAGES_QUERY($searchTerm: String!, $onAction: Boolean, $approved: Boolean) {
    searchMessages(searchTerm: $searchTerm, onAction: $onAction, approved: $approved) {
      id
      name
      details
      template {
        id
        status
      }
    }
  }
`
export const SEARCH_TREASURIES_QUERY = gql`
  query SEARCH_TREASURIES_QUERY($searchTerm: String!) {
    searchTreasuries(searchTerm: $searchTerm) {
      id
      name
    }
  }
`
export const SEARCH_PRESCRIPTION_TEMPLATES = gql`
  query SEARCH_PRESCRIPTION_TEMPLATES($searchTerm: String!) {
    searchPrescriptionTemplates(searchTerm: $searchTerm) {
      id
      name
    }
  }
`
export const CREATED_APPOINTMENTS = gql`
  query CREATED_APPOINTMENTS(
    $doctor: ID
    $branchId: ID
    $userId: ID
    $id: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $searchTerm: String
    $rangeDate: [DateTime!]!
    $filters: Filter
    $forDashboard: Boolean
    $currentUserTime: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    createdAppointments(
      doctor: $doctor
      branchId: $branchId
      userId: $userId
      patient: $id
      orderBy: $orderBy
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      filters: $filters
      forDashboard: $forDashboard
      currentUserTime: $currentUserTime
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      start
      end
      diagnosticFee
      urgent
      pending
      isOnline
      whatsapp
      alert
      repeat
      duration
      waitingDuration
      reschedule
      patientConfirm
      started
      checked
      room
      type
      other
      onlinePayment
      diagnosticFeeInvoice {
        id
        paidInFull
        diagnosticFee
      }
      appointmentFeedback {
        id
        rating
        feedback
      }
      assistants {
        id
        name
        color
      }
      customFields {
        id
        value
        field {
          id
          name
        }
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        phoneNumber2
        email
        pending
        details
        title
        nationality
        nationalId
        referralDetails
        patientId
        birthDate
        referenceId
        patientTags {
          id
          name
          color
          icon
          hasNextTags
        }
        referralSource {
          id
          name
          color
        }
        referralSubSource {
          id
          name
          color
        }
        totalRemaining
        totalPaid
        firstPaymentDate
        dailyAmountPaid
        lastPaymentDate
        prevAppointment {
          id
          room
          status
          start
        }
        activeAppointment {
          id
          room
          status
          start
        }
        lastAppointment {
          id
          room
          status
          start
        }
        createdAt
        insuranceCompany {
          id
          name
          number
        }
        hasMedicalAlerts
        hasPendingMedical
        remainingPackage
        tax
        labOrders {
          id
          name
          details
          due
          lab {
            id
            name
          }
        }
      }
      status
      details
      title
      doctor {
        id
        name
        color
      }
      branch {
        id
        name
      }
      createdAt
      after
      interval
      cancelReason
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const TOTAL_CREATED_APPOINTMENTS = gql`
  query TOTAL_CREATED_APPOINTMENTS(
    $doctor: ID
    $branchId: ID
    $userId: ID
    $id: ID
    $searchTerm: String
    $rangeDate: [DateTime!]!
    $filters: Filter
    $forDashboard: Boolean
    $currentUserTime: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    totalCreatedAppointments(
      doctor: $doctor
      branchId: $branchId
      userId: $userId
      patient: $id
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      filters: $filters
      forDashboard: $forDashboard
      currentUserTime: $currentUserTime
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    )
  }
`

export const GET_CALENDAR_QUERY = gql`
  query GET_CALENDAR_QUERY(
    $branch: ID!
    $start: DateTime!
    $end: DateTime!
    $doctor: ID
    $rooms: [String]
    $forNewAppointment: Boolean
  ) {
    calendar(branch: $branch, start: $start, end: $end, doctor: $doctor, rooms: $rooms, forNewAppointment: $forNewAppointment) {
      id
      status
      urgent
      isOnline
      pending
      whatsapp
      start
      end
      title
      details
      alert
      repeat
      room
      diagnosticFee
      type
      reschedule
      patientConfirm
      createdAt
      after
      interval
      cancelReason
      waitingDuration
      checked
      other
      onlinePayment
      diagnosticFeeInvoice {
        id
        paidInFull
        diagnosticFee
      }
      assistants {
        id
        name
        color
      }
      customFields {
        id
        value
        field {
          id
        }
      }
      doctor {
        id
        name
        phoneNumber
        color
      }
      createdBy {
        id
        name
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        hasValidNumber
        phoneNumber2
        email
        pending
        patientId
        referenceId
        title
        birthDate
        patientTags {
          id
          name
          color
          icon
          hasNextTags
        }
        insuranceEndDate
        insuranceCompany {
          id
          name
          number
        }
        birthDay
        details
        totalRemaining
        totalPaid
        hasMedicalAlerts
        hasPendingMedical
        remainingPackage
        tax
        labOrders {
          id
          name
          details
          due
          lab {
            id
            name
          }
        }
      }
    }
  }
`

export const DATE_RANGE_APPOINTMENTS = gql`
  query DATE_RANGE_APPOINTMENTS($branch: ID!, $start: DateTime!, $end: DateTime!) {
    dateRangeAppointments(branch: $branch, start: $start, end: $end) {
      id
      start
      end
      patientId
      doctorId
      pending
      createdById
      room
      status
      type
      assistants {
        id
      }
    }
  }
`

export const APPOINTMENT_WAITING_INFO = gql`
  query APPOINTMENT_WAITING_INFO($appointment: ID!) {
    appointmentWaitingInfo(appointment: $appointment) {
      id
      start
      end
      status
      waitingDuration
      whatsapp
      pushname
      pending
      diagnosticFee
      onlinePayment
      diagnosticFeeInvoice {
        id
        paidInFull
      }
      appointmentFeedback {
        id
      }
      branch {
        id
        name
        address
        phones
        company {
          id
          companyName
          code
          country
          allowMedicalQR
          companyLogo
          hideQueue
          requiredPatientFields
          requiredQrPatientFields
          defaultLanguage
          visiblePatientFields
          extraSettings
          currency
          timeZone
          debounceTime
          googleEnabled
          patientPointsSettings {
            id
            feedbackPoints
          }
        }
      }
      patient {
        id
        firstName
        lastName
        points {
          id
          firstToExpire
          remaining
        }
      }
    }
  }
`

export const APPOINTMENTS_INFO = gql`
  query APPOINTMENTS_INFO(
    $doctor: ID
    $branchId: ID
    $userId: ID
    $id: ID
    $searchTerm: String
    $rangeDate: [DateTime!]!
    $filters: Filter
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    appointmentsInfo(
      doctor: $doctor
      branchId: $branchId
      userId: $userId
      patient: $id
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      filters: $filters
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      appointments {
        status
        _count
      }
    }
  }
`

export const APPOINTMENTS_DETAILS = gql`
  query APPOINTMENTS_DETAILS($appointment: ID!) {
    appointmentDetails(appointment: $appointment) {
      id
      start
      end
      diagnosticFee
      diagnosticFeeInvoice {
        id
        paidInFull
        diagnosticFee
      }
      urgent
      isOnline
      pending
      whatsapp
      alert
      repeat
      duration
      waitingDuration
      reschedule
      patientConfirm
      started
      ended
      checked
      onlinePayment
      room
      type
      other
      customFields {
        id
        value
        field {
          id
        }
      }
      appointmentFeedback {
        id
        rating
        feedback
      }
      assistants {
        id
        name
        color
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        phoneNumber2
        email
        pending
        details
        title
        patientTags {
          id
          name
          color
          hasNextTags
        }
        referralSource {
          id
          name
          color
        }
        referralSubSource {
          id
          name
          color
        }
        birthDate
        patientId
        referenceId
        totalRemaining
        totalPaid
        insuranceCompany {
          id
          name
          taxPercent
        }
        insured
        insuranceLimit
        insuranceUnlimited
        approvalRequired
        insurancePercentage
        insuranceEndDate
        insuranceStartMonth
        priceList {
          id
          name
          syncTo
          difference
          percentage
        }
        policyClass {
          id
          name
          maxLimit
          insuranceLimit
          insuranceUnlimited
          insurancePercentage
          approvalRequired
        }
        hasMedicalAlerts
        hasPendingMedical
        remainingPackage
        tax
        labOrders {
          id
          name
          details
          due
          lab {
            id
            name
          }
        }
      }
      status
      details
      title
      doctor {
        id
        name
        color
      }
      branch {
        id
        name
      }
      _count {
        canals
        notes
        operations
        xrays
        prescriptions
        freeForms
        operationSteps
        updatedOperations
        updatedOperationSteps
        files
        invoices
        payments
        labOrders
        inventoryOrders
        quotations
        clinicalTests
        encounters
        reminders
      }
      createdAt
      after
      interval
      cancelReason
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const COMPANY_DETAILS_FOR_PATIENT_QR = gql`
  query COMPANY_DETAILS_FOR_PATIENT_QR($register: ID!) {
    companyDetailsForPatientQr(register: $register) {
      id
      name
      phoneNumber
      hasMedical
      company {
        id
        companyName
        code
        country
        allowMedicalQR
        companyLogo
        hideQueue
        requiredPatientFields
        requiredQrPatientFields
        defaultLanguage
        visiblePatientFields
        extraSettings
        debounceTime
        googleEnabled
        medicalGroups {
          id
          name
          order
          showAlert
          active
          items {
            id
            name
            required
            hidden
            active
            gender
            type
            order
            options
            createdAt
            updatedAt
            createdBy {
              id
              name
            }
            updatedBy {
              id
              name
            }
          }
        }
      }
    }
  }
`
